import axios from 'axios';
import {ENDPOINT_URL, GET_CLIENT_LIST} from '../../../constants/commonConstants';
import {decodeAgentResponse} from '../../core/resolutionUtils';

/**
 * Read a whole number from an API value.
 * @param {*} value API value
 * @return {number} count
 */
function count(value) {
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : 0;
}

/**
 * Report how many clients are connected.
 *
 * Read from the list endpoint's own count rather than tallied from rows: the
 * table holds five at a time and the estate runs to five figures, so counting
 * what is on screen would be wrong by four orders of magnitude. One row is
 * asked for and thrown away - the count travels beside it.
 *
 * The same query the table would run, so the answer always matches what
 * "show them" would then display: a Site narrows it, and a search term
 * narrows it the way the search box does.
 *
 * @param {object} command read_statistic command
 * @return {Promise<{values: {connected: number}}>} counts
 */
export async function readClientCounts(command = {}) {
	const siteId = command.params?.site_id;
	const query = String(command.params?.query || '').trim();
	let url = `${ENDPOINT_URL}${GET_CLIENT_LIST}?limit=1&offset=0`;
	if (siteId) url += `&group=${encodeURIComponent(String(siteId))}`;
	if (query) url += `&searchfilter=${encodeURIComponent(query)}`;
	const {data} = await axios.get(url);
	const document = decodeAgentResponse(data) || {};
	// A filtered request reports both: the matches, and the estate behind it.
	const connected = query
		? count(document?.filtered_count ?? document?.count)
		: count(document?.count);
	// Canvas counts the two bands for us and puts the totals beside the
	// overall one - it is what the Home header shows as "(5GHz: x, 2.4GHz:
	// y)". The band cannot be searched or filtered on, which is why asking
	// for 5 GHz clients used to answer with the whole estate; counting one
	// is a different question, and this is the answer to it.
	return {
		values: {
			connected,
			band_5: count(document?.client_count_5),
			band_24: count(document?.client_count_24),
		},
	};
}
